import { NgModule } from '@angular/core';
import { CartBaseCoreModule, CartPageEventModule } from '@spartacus/cart/base/core';
import { CartBaseOccModule } from '@spartacus/cart/base/occ';
import { AddToWishListModule } from '@spartacus/cart/wish-list/components/add-to-wishlist';
import {
  CheckoutComponentsModule, CheckoutLoginModule
} from '@spartacus/checkout/base/components';
import { CheckoutCoreModule } from '@spartacus/checkout/base/core';
import { CheckoutOccModule } from '@spartacus/checkout/base/occ';
import {
  AnonymousConsentsModule, AuthModule,
  CostCenterOccModule, ProductModule, ProductOccModule,
  provideFeatureToggles,
  UserModule, UserOccModule
} from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule, AnonymousConsentsDialogModule, BannerCarouselModule, BannerModule,
  BreadcrumbModule, CategoryNavigationModule,
  CmsParagraphModule, ConsentManagementModule, FooterNavigationModule, HamburgerMenuModule,

  HomePageEventModule, LinkModule, LoginRouteModule, MyCouponsModule, MyInterestsModule,
  NavigationEventModule, NavigationModule, NotificationPreferenceModule,
  PaymentMethodsModule, ProductCarouselModule, ProductDetailsPageModule,
  ProductFacetNavigationModule, ProductImagesModule, ProductIntroModule, ProductListingPageModule, ProductListModule,
  ProductPageEventModule, ProductReferencesModule, ProductSummaryModule, ProductTabsModule, PwaModule, SearchBoxModule,
  SiteContextSelectorModule, StockNotificationModule, TabParagraphContainerModule
} from '@spartacus/storefront';
import { AddressBookModule } from "@spartacus/user/profile/components";
import { QualtricsFeatureModule } from './features/qualtrics/qualtrics-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { AsmModule} from '@spartacus/asm';
import { AsmFeatureModule } from './features/asm/asm-feature.module'
import { CdcFeatureModule } from './features/cdc/cdc-feature.module';
@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    // LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    // User Core,
    UserOccModule,
    UserModule,
    //ASM Module
    AsmModule,
    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    // Anonymous Consents Core,
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI,
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    // Cart Core,
    CartBaseCoreModule,
    CartBaseOccModule,
    // Cart UI,

    AddToWishListModule,
    // Checkout Core,  
    CheckoutCoreModule,
    CheckoutOccModule,
    CostCenterOccModule,
    // Checkout UI,
    CheckoutLoginModule,
    CheckoutComponentsModule,

    // Order,

    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,
    UserFeatureModule,
    QualtricsFeatureModule,
    SmartEditFeatureModule,
    //AsmFeatureModule,
    PwaModule,
    CdcFeatureModule

  ],
  providers:[provideFeatureToggles({
    unifiedDefaultHeaderSlotsAcrossBreakpoints:false,
      // Enable OAuth Authorization Code Flow
      authorizationCodeFlowByDefault: false,
      // incrementProcessesCountForMergeCart: true,
      // dispatchLoginActionOnlyWhenTokenReceived: true,
      // cdsLoginEventsToken: true
  })]
})
export class SpartacusFeaturesModule { }